import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Merge Detail|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityMergeDetail';
export type SPCandidateSystemActivityMergeDetailLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}NotificationUnmergeRequestSuccess`
	| `${LocNameStart}TitleMergeSummary`
	| `${LocNameStart}ButtonCompleteUnmerge`
	| `${LocNameStart}LabelMergedOn`
	| `${LocNameStart}LabelApprovedBy`
	| `${LocNameStart}TitleOtherRequirements`
	| `${LocNameStart}TitleCandidateIds`
	| `${LocNameStart}TitleExams`
	| `${LocNameStart}TitleWinner`
	| `${LocNameStart}TitleLoser`;

export const spCandidateSystemActivityMergeDetailLocs: LocDefs<SPCandidateSystemActivityMergeDetailLocNames> =
	{
		SPCandidateSystemActivityMergeDetailTitlePage: {
			defaultValue: 'Merge Details',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Title.PageTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailNotificationUnmergeRequestSuccess: {
			defaultValue: 'Unmerge succesfully requested',
			description: 'Unmerge succesfully requested notification',
			displayPath: `${pathStart}Unmerge succesfully requested`,
			displayType: 'Notification',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.UnmergeRequestSuccess',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailTitleMergeSummary: {
			defaultValue: 'Merge Summary',
			description: 'Merge Summary Title',
			displayPath: `${pathStart}Merge Summary`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Title.MergeSummary',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailButtonCompleteUnmerge: {
			defaultValue: 'Complete Unmerge',
			description: 'Complete Unmerge button',
			displayPath: `${pathStart}Complete Unmerge`,
			displayType: 'Button',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Button.RequestUnmerge',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailLabelMergedOn: {
			defaultValue: 'Merged On',
			description: 'Label for: Merged On.',
			displayPath: `${pathStart}Merged On`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.FieldLabel.MergedOn',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailLabelApprovedBy: {
			defaultValue: 'Approved By',
			description: 'Label for: Approved By.',
			displayPath: `${pathStart}Approved By`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.FieldLabel.ApprovedBy',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailTitleOtherRequirements: {
			defaultValue: 'Other Requirements',
			description: 'Other Requirements Title',
			displayPath: `${pathStart}Other Requirements`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Title.OtherRequirements',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailTitleCandidateIds: {
			defaultValue: 'Candidate IDs',
			description: 'Candidate IDs Title',
			displayPath: `${pathStart}Candidate IDs`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Title.CandidateIDs',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailTitleExams: {
			defaultValue: 'Exams',
			description: 'Exams Title',
			displayPath: `${pathStart}Exams`,
			displayType: 'Title',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Title.Exams',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailTitleLoser: {
			defaultValue: 'Loser',
			description: 'Loser Title',
			displayPath: `${pathStart}Loser`,
			displayType: 'Title',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetails.Title.Loser',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailTitleWinner: {
			defaultValue: 'Winner',
			description: 'Winner Title',
			displayPath: `${pathStart}Winner`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetails.Title.Winner',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityMergeDetailLocType =
	LocMap<SPCandidateSystemActivityMergeDetailLocNames>;
